import Dropdown from 'components/common/Dropdown';
import DropdownClickableItem from 'components/common/DropdownClickableItem';
import useTranslation from 'next-translate/useTranslation';
import {
  CopySimple,
  Envelope,
  FacebookLogo,
  LinkedinLogo,
  TwitterLogo,
  WhatsappLogo,
} from '@phosphor-icons/react';
import { FunctionComponent } from 'react';
import { DropdownProps } from 'types/dropdown.type';

const VehicleDetailShareDropdown: FunctionComponent<DropdownProps> = ({
  show,
  onClose,
}) => {
  const { t } = useTranslation();

  const closedClick = (cb: () => void) => {
    return () => {
      cb();
      onClose?.();
    };
  };

  const dropdownItems = [
    {
      icon: CopySimple,
      text: t('vehicle:copyLink'),
      action: () => {
        navigator.clipboard.writeText(window.location.href);
      },
    },
    {
      icon: Envelope,
      text: t('vehicle:email'),
      action: () => {
        window.open(`mailto:?body=${window.location.href}`, '_blank');
      },
    },
    {
      icon: FacebookLogo,
      text: 'Facebook',
      action: () => {
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
          '_blank'
        );
      },
    },
    {
      icon: TwitterLogo,
      text: 'Twitter',
      action: () => {
        window.open(
          `https://twitter.com/messages/compose?text=${window.location.href}`,
          '_blank'
        );
      },
    },
    {
      icon: LinkedinLogo,
      text: 'LinkedIn',
      action: () => {
        window.open(
          `https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`,
          '_blank'
        );
      },
    },
    {
      icon: WhatsappLogo,
      text: 'WhatsApp',
      action: () => {
        window.open(`whatsapp://send/?text=${window.location.href}`, '_blank');
      },
    },
  ];

  return (
    <Dropdown show={show} onClose={onClose}>
      <>
        {dropdownItems.map((item) => (
          <DropdownClickableItem
            key={`share-${item.text}`}
            onClick={closedClick(item.action)}
          >
            <div className="flex items-center gap-2">
              <item.icon className="inline-block h-5 w-5" />
              <span>{item.text}</span>
            </div>
          </DropdownClickableItem>
        ))}
      </>
    </Dropdown>
  );
};

export default VehicleDetailShareDropdown;
